import api from './index.js'

export function getFaqList(params) {
  return api.get('/api/v1/faqs', { params })
}

export function getFaqDetail(boardCode) {
  return api.get(`/api/v1/faqs/${encodeURIComponent(boardCode)}`)
}

export function createFaq(body) {
  return api.post('/api/v1/faqs', body)
}

export function updateFaq(boardCode, body) {
  return api.put(`/api/v1/faqs/${encodeURIComponent(boardCode)}`, body)
}

export function deleteFaq(boardCode) {
  return api.delete(`/api/v1/faqs/${encodeURIComponent(boardCode)}`)
}
